<div
  id="drop"
  class="upload-file-control-new"
  #drop
  ngx-dropzone
  (change)="onFileChange($event)"
  [accept]="fileFormat"
  fxLayout="column"
  fxLayoutAlign="stretch center"
>
  <div fxLayout="row" fxLayoutAlign="center center">
    <i class="mr-3 icon icon-cloud_upload"></i>
    <span class="file-upload-label">{{ label }}</span>
  </div>
</div>
